import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  CardActionArea,
  Container,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import "./LessonSliderPreview.css";
import "./responsive.css";

import heading from "../../images/heading.png";
import slide1 from "../../images/book_circle_1.png";
import slide2 from "../../images/book_circle_2.png";
import slide3 from "../../images/book_circle_3.png";
import slide4 from "../../images/book_circle_4.png";
import slide5 from "../../images/book_circle_5.png";
import slide6 from "../../images/book_circle_6.png";

const lessons = [
  { image: slide1, to: "/class/8/int/yac/modules", label: "Інтегрована література" },
  { image: slide2, to: "/class/8/ukrmova/gol/modules", label: "Українська мова" },
  { image: slide3, to: "/class/8/ukrlit/yac/modules", label: "Українська література" },
  { image: slide4, to: "/class/8/ukrlit/avr/modules", label: "Література" },
  { image: slide5, to: "/class/8/zbd/pol/modules", label: "Здоров'я та безпека" },
  { image: slide6, to: "/class/8/ukrmova/avr/modules", label: "Українська мова" },
];

function LessonSliderPreview() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallDesktop = useMediaQuery(theme.breakpoints.down("lg"));
  const [activeIndex, setActiveIndex] = useState(0);
  const [transitionEnabled, setTransitionEnabled] = useState(true);

  const visibleCount = isMobile ? 1 : isTablet ? 2 : isSmallDesktop ? 3 : 4;

  useEffect(() => {
    setActiveIndex(0);
  }, [visibleCount]);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveIndex((current) => current + 1);
    }, 2800);

    return () => window.clearInterval(timer);
  }, []);

  const carouselLessons = useMemo(() => {
    return [...lessons, ...lessons.slice(0, visibleCount)];
  }, [visibleCount]);

  const handleTransitionEnd = () => {
    if (activeIndex < lessons.length) return;

    setTransitionEnabled(false);
    setActiveIndex(0);
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => setTransitionEnabled(true));
    });
  };

  return (
    <Box component="section" className="lesson-slider-baloon">
      <Container maxWidth="lg">
        <Box className="heading">
          <img alt="" src={heading} />
          <Typography variant="h2" component="h1">
            ОБИРАЙ ВПРАВИ
          </Typography>
          <Typography component="p">
            Обирай вправи для перевірки знань!
          </Typography>
        </Box>

        <Box className="mui-lesson-carousel">
          <Box
            className="mui-lesson-carousel__track"
            onTransitionEnd={handleTransitionEnd}
            style={{
              "--visible-lessons": visibleCount,
              "--active-index": activeIndex,
              transition: transitionEnabled ? undefined : "none",
            }}
          >
            {carouselLessons.map((lesson, index) => (
              <CardActionArea
                key={`${lesson.to}-${index}`}
                component={Link}
                to={lesson.to}
                className="mui-lesson-card"
              >
                <Box
                  component="img"
                  src={lesson.image}
                  alt={lesson.label}
                  className="mui-lesson-card__image"
                />
              </CardActionArea>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default LessonSliderPreview;
